import gql from 'graphql-tag';

export default gql`
  mutation activateIntegration($integrationId: ID!, $key: String!) {
    integration: activateIntegration(integrationId: $integrationId, key: $key) {
      id
      status
      type
    }
  }
`;
